// extracted by mini-css-extract-plugin
module.exports = {"navDefault":"styles_navDefault__2amTc","navActive":"styles_navActive__3O4wn"};